import script from "./YoutubeVideoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./YoutubeVideoButton.vue?vue&type=script&setup=true&lang=js"

import "./YoutubeVideoButton.vue?vue&type=style&index=0&id=c4ad7006&scoped=true&lang=css"

import exportComponent from "/Users/tome/devbox/tz-razanac.test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4ad7006"]])

export default __exports__